var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("v-text-field", {
        staticClass: "mb-3",
        attrs: {
          "prepend-inner-icon": "mdi-magnify",
          label: "Buscar menu",
          dense: "",
          outlined: "",
          clearable: "",
          "hide-details": "",
        },
        model: {
          value: _setup.search,
          callback: function ($$v) {
            _setup.search = $$v
          },
          expression: "search",
        },
      }),
      _c(
        "v-card",
        { attrs: { outlined: "" } },
        [
          _c(
            "v-card-title",
            { staticClass: "py-2 subtitle-2 grey--text text--darken-2" },
            [
              _c(
                "v-icon",
                {
                  staticClass: "mr-2",
                  attrs: { small: "", color: "grey darken-1" },
                },
                [_vm._v("mdi-sitemap")]
              ),
              _vm._v(" Permissão em menu "),
              _c("v-spacer"),
              _c(
                "v-chip",
                {
                  attrs: {
                    "x-small": "",
                    label: "",
                    outlined: "",
                    color: "primary",
                  },
                },
                [_vm._v(_vm._s(_setup.selected.length) + " selecionado(s)")]
              ),
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-card-text",
            {
              style: _vm.scrollable
                ? { maxHeight: _vm.maxHeight + "px", overflowY: "auto" }
                : {},
            },
            [
              _setup.loading
                ? _c(
                    "div",
                    { staticClass: "text-center grey--text py-4" },
                    [
                      _c("v-progress-circular", {
                        attrs: { indeterminate: "", size: "22", color: "grey" },
                      }),
                    ],
                    1
                  )
                : [
                    _setup.menus.length
                      ? _c("v-treeview", {
                          attrs: {
                            items: _setup.menus,
                            search: _setup.search,
                            selectable: "",
                            "selection-type": "independent",
                            "item-text": "name",
                            dense: "",
                          },
                          on: { input: _setup.apply },
                          model: {
                            value: _setup.selected,
                            callback: function ($$v) {
                              _setup.selected = $$v
                            },
                            expression: "selected",
                          },
                        })
                      : _c(
                          "div",
                          {
                            staticClass: "text-center grey--text py-4 caption",
                          },
                          [_vm._v("Nenhum menu disponível.")]
                        ),
                  ],
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }